module.exports = __webpack_public_path__ + "static/media/github.d6b316ac.svg";